import { Component } from '@angular/core';

@Component({
  selector: 'show-Component',
  template:`
  <h1 (click)="showEvent()" >Tour of Heroes</h1>
  `,
  styles: [`h1 { 
    font-weight: normal; 
  } 
  .padding{padding:10px;}`
]

})
export class ShowComponent {
  title = 'testingliib';
  showEvent(){
      console.log("show")
  }
}